"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const classes_1 = require("../classes");
class TaskScheduledEvent extends classes_1.HistoryEvent {
    constructor(options) {
        super(classes_1.HistoryEventType.TaskScheduled, options.eventId, options.isPlayed, options.timestamp);
        if (options.name === undefined) {
            throw new Error("TaskScheduledEvent needs a name provided.");
        }
        this.Input = options.input;
        this.Name = options.name;
    }
}
exports.TaskScheduledEvent = TaskScheduledEvent;
//# sourceMappingURL=taskscheduledevent.js.map